// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7840":"0fc2fb9ad2957f97","8743":"cb43199d8e6b8cfe"}[chunkId] + ".css";
};